export const LOAD_ANIMATION_CONFIG = {
  renderer: "svg",
};

export const EVENT = {
  DATA_READY: "data_ready",
};
